// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28kto","label":"styles_label__2BgzK"};